import { ApplicationConfig } from '@angular/core';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { provideRouter } from '@angular/router';
import { provideAnimations } from '@angular/platform-browser/animations';
import { ToastrModule } from 'ngx-toastr';
import { importProvidersFrom } from '@angular/core';
import { MatDialogModule } from '@angular/material/dialog';
import { FormsModule } from '@angular/forms';
import { routes } from './app.routing';
import { pagesRoutes } from './pages/pages.routing';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { idmInterceptor } from './idm.interceptor';

export const appConfig: ApplicationConfig = {
  providers: [
    provideHttpClient(withInterceptors([idmInterceptor])),
    provideAnimations(),
    provideRouter([...routes, ...pagesRoutes]),
    importProvidersFrom(
      FormsModule,
      MatDialogModule,
      MatProgressSpinnerModule,
      ToastrModule.forRoot({
        positionClass: 'toast-bottom-right',
        progressBar: true,
        maxOpened: 3,
        autoDismiss: true,
      }),
    ),
  ],
};
